import * as React from 'react';
import PropTypes from 'prop-types';
import buildClassNames from 'classnames';
import { COMPONENT_BG_COLOR } from '../../utilities/themeColor';
import './Tier.scss';

const Tier = ({ children, classNames, theme, showBottomDivider }) => (
    <div
        className={buildClassNames('tier', classNames, {
            'tier--white': theme === COMPONENT_BG_COLOR.WHITE,
            'tier--light-gray': theme === COMPONENT_BG_COLOR.LIGHT_GRAY,
            'tier--dark-gray': theme === COMPONENT_BG_COLOR.DARK_GRAY,
            'tier--blue': theme === COMPONENT_BG_COLOR.BLUE,
            'tier--divider-bottom': showBottomDivider,
        })}>
        <div className="tier__inner">{children}</div>
    </div>
);

Tier.propTypes = {
    children: PropTypes.node.isRequired,
    classNames: PropTypes.string,
    theme: PropTypes.string.isRequired,
    showBottomDivider: PropTypes.bool,
};

Tier.defaultProps = {
    classNames: null,
    showBottomDivider: false,
};

export default Tier;
